import fs from 'fs';
import path from 'path';

export function resolveUnderRepo(repoRoot: string, targetPath: string): string {
  const absRoot = path.resolve(repoRoot);
  const resolved = path.resolve(absRoot, targetPath);
  ensureWithinRepo(absRoot, resolved);
  return resolved;
}

export function ensureWithinRepo(repoRoot: string, absTarget: string): void {
  const rel = path.relative(path.resolve(repoRoot), path.resolve(absTarget));
  if (rel.startsWith('..') || path.isAbsolute(rel)) {
    throw new Error(`Path outside repository root: ${absTarget}`);
  }
}

export function toRepoRelative(repoRoot: string, absPath: string): string {
  return path.relative(path.resolve(repoRoot), path.resolve(absPath));
}

export function isSymlink(p: string): boolean {
  try {
    const st = fs.lstatSync(p);
    return st.isSymbolicLink();
  } catch {
    return false;
  }
}

/**
 * Detects and removes consecutive duplicate path segments.
 *
 * When the model predicts a path that includes the repo directory name,
 * joining with repoRoot creates duplication:
 *   repoRoot="/Users/dhruv/repo" + predicted="repo/src/file.ts"
 *   → "/Users/dhruv/repo/repo/src/file.ts"
 *
 * This function detects such patterns and returns the corrected path,
 * or null if no duplication is found.
 */
export function fixPathRepetition(fullPath: string): string | null {
  const segments = fullPath.split(path.sep).filter(Boolean);
  if (segments.length < 2) return null;

  for (let len = Math.floor(segments.length / 2); len >= 1; len--) {
    for (let i = 0; i <= segments.length - 2 * len; i++) {
      const first = segments.slice(i, i + len);
      const second = segments.slice(i + len, i + 2 * len);

      if (first.every((seg, idx) => seg === second[idx])) {
        const fixed = [...segments.slice(0, i), ...segments.slice(i + len)];
        return path.sep + fixed.join(path.sep);
      }
    }
  }

  return null;
}

export function isTextualFile(filePath: string, maxBytes = 2_000_000): boolean {
  try {
    const st = fs.statSync(filePath);
    if (!st.isFile()) return false;
    if (st.size > maxBytes) return false;
    const fd = fs.openSync(filePath, 'r');
    const buf = Buffer.alloc(512);
    const read = fs.readSync(fd, buf, 0, buf.length, 0);
    fs.closeSync(fd);
    for (let i = 0; i < read; i++) {
      const c = buf[i];
      if (c === 0) return false; // binary heuristic
    }
    return true;
  } catch {
    return false;
  }
}


